module.exports = __webpack_public_path__ + "fonts/roboto-vietnamese-400-normal.ca3b09b6.woff2";